import { ModalForm } from "modules/app/styles"
import { Input, ModalBody } from "reactstrap"
import { ImageLinkFooter, ImagePreview, StyledSearchInput } from "./styles"
import { ReactComponent as UrlLinkIcon } from "assets/images/icons/url_link.svg"
import { useEffect, useState } from "react"
import { CustomButton } from "modules/auth/styles"

const ImageLinkUpload = ({ handleSubmissionOfMedia, setCoverModal }) => {
  const [imageLink, setImageLink] = useState('');
  const [isImageValid, setIsImageValid] = useState(true);

  useEffect(() => {
    if (imageLink.length) {
      new Promise((resolve) => {
        const img = new Image();

        img.src = imageLink;

        img.onload = () => {
          setIsImageValid(true)
          resolve('success');
        }

        img.onerror = () => {
          setIsImageValid(false);
          resolve('failed');
        }
      });
    }
    else {
      setIsImageValid(true)
    }
  }, [imageLink])

  return (
    <>
      <ModalBody>
        <ModalForm>
          <div className='title'>Change Cover Image</div>

          <div className='my-auto d-flex flex-column' style={{ height: '90%' }}>
            <div className='font-weight-600 my-4' style={{ fontSize: '1.14rem' }}>Image Link</div>
          </div>
          <StyledSearchInput isImageValid={isImageValid} fromImageUrl={true}>
            <UrlLinkIcon />
            <Input
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                }
              }}
              type="text" onChange={(e) => setImageLink(e.target.value)} className="custom-input" placeholder="https://klutch.app/image/link.png" />
          </StyledSearchInput>
        </ModalForm>

        <ImagePreview>
          {(imageLink?.length && isImageValid) ? <img src={imageLink} alt="Preview" /> : 'Image Preview'}
        </ImagePreview>

        <ImageLinkFooter>
          <CustomButton className="black shadow-none" disabled={!imageLink?.length || !isImageValid} onClick={() => handleSubmissionOfMedia(false, imageLink)}>Insert</CustomButton>
          <CustomButton className={'gray shadow-none'} onClick={() => setCoverModal(false)}>Cancel</CustomButton>
        </ImageLinkFooter>
      </ModalBody>
    </>
  )
}

export default ImageLinkUpload